export default __webpack_public_path__ + "static/ay-hero-2028819680355a3526bac2eed4f65479.jpeg";